import { AxisId } from 'ff/debrief/models';

export { default as AxisSelectField } from './AxisSelectField';
export { default as AxisSelectForm } from './AxisSelectForm';

export const axisLabel: { [key in AxisId]: string } = {
    above_ground_level: 'Altitude (AGL)',
    airspeed: 'Airspeed (IAS)',
    altitude: 'Altitude (MSL)',
    bank: 'Bank',
    g_load: 'G Load',
    ground_speed: 'Ground Speed',
    pitch: 'Pitch',
    terrain_elevation: 'Terrain',
};

export const axisConfig: { [key in AxisId]: { label: string; color: string } } =
    {
        above_ground_level: { label: 'Altitude (AGL)', color: '#FC3D82' },
        airspeed: { label: 'Airspeed (IAS)', color: '#1ABC9C' },
        altitude: { label: 'Altitude (MSL)', color: '#3399FF' },
        bank: { label: 'Bank', color: '#E67E22' },
        g_load: { label: 'G Load', color: '#850DB7' },
        ground_speed: { label: 'Ground Speed', color: '#0D9345' },
        pitch: { label: 'Pitch', color: '#C0392B' },
        terrain_elevation: { label: 'Terrain', color: '#BA7B19' },
    };
